<div class="scaffold-sidebar-overlay">
  <div style="display:flex;">
    <div style="flex:1;">
      <div class="scaffold-editor-panel-heading">{{view?.panel_title||'settings'| translation}}</div>
    </div>
    <div>
      <p-button severity="contrast" variant="text" size='large' (click)="close()" aria-label="Close properties panel"><i class="fas fa-times"></i></p-button>
    </div>
  </div>
  <hr />
  <div class="sidebar-scroll-area">


    <app-view *ngIf="view" [items]="view.content" [info]="info" [data]="view_data"></app-view>
  </div>
</div>
